import React from 'react';
import { trackWhatsAppClick, trackCallClick } from '../../../utils/gtm';
import { IconPhone, IconWhatsApp } from './Icons';

const TRADE_LICENCE = '795106';

const SiteFooter = () => (
  <footer className="bk-footer" data-screen-label="Footer">
    <div className="bk-container">
      <div className="bk-footer-grid">
        <div className="bk-footer-col bk-footer-about">
          <a href="/" className="bk-footer-logo" aria-label="Standard Auditing, home">
            <img
              src="/standard-auditing-logo-1.webp"
              alt="Standard Auditing"
              width="149"
              height="45"
              loading="lazy"
              decoding="async"
            />
          </a>
          <p className="bk-footer-desc">
            Independent private tax and audit consulting firm based in Dubai, UAE. We are not affiliated with the
            Federal Tax Authority (FTA) or any UAE government entity, and we do not issue government documents or
            official services.
          </p>
          <p className="bk-footer-licence">Trade License No. {TRADE_LICENCE}</p>
        </div>

        <div className="bk-footer-col">
          <h3 className="bk-footer-title">Contact</h3>
          <a
            href="tel:+971542119784"
            className="bk-footer-link gtm-phone-link"
            data-gtm-id="footer-phone-link"
            onClick={() => trackCallClick('footer_phone')}
          >
            <IconPhone size={16} />
            <span>+971 54 211 9784</span>
          </a>
          <a
            href="https://wa.me/971542119784"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackWhatsAppClick('home_footer_link')}
            className="bk-footer-link gtm-whatsapp-btn"
            data-gtm-id="footer-whatsapp"
          >
            <IconWhatsApp size={17} />
            <span>WhatsApp Us</span>
          </a>
          <address className="bk-footer-address">
            Standard Auditing, NBQ Building – 112
            <br />
            Khalid Bin Al Waleed Rd, Al Mankhool
            <br />
            Dubai, United Arab Emirates
          </address>
        </div>

        <div className="bk-footer-col">
          <h3 className="bk-footer-title">Legal</h3>
          <a href="#privacy" className="bk-footer-link">Privacy Policy</a>
          <a href="#terms" className="bk-footer-link">Terms of Service</a>
          <a href="#refund" className="bk-footer-link">Refund &amp; Cancellation Policy</a>
        </div>
      </div>

      <p className="bk-footer-bottom">
        © 2026 Standard Auditing. All rights reserved. Independent private advisory firm — not a government authority.
      </p>
    </div>
  </footer>
);

export default SiteFooter;
